export interface FoundTextOccurance {
  startIndex: number;
  length: number;
}

export function findSubstrings(s: string, needle: string): FoundTextOccurance[] {
  const result: FoundTextOccurance[] = [];

  let startingIndex = 0;
  // eslint-disable-next-line no-constant-condition -- it's fine
  while (true) {
    const foundIndex = s.indexOf(needle, startingIndex);
    if (foundIndex >= 0) {
      result.push({ startIndex: foundIndex, length: needle.length });
      startingIndex = foundIndex + needle.length;
    } else {
      break;
    }
  }

  return result;
}

export function findRegex(s: string, regex: RegExp): FoundTextOccurance[] {
  const occurances: FoundTextOccurance[] = [];

  const result = Array.from(s.matchAll(regex));
  result.map((i) => {
    if (typeof i.index !== 'undefined') {
      occurances.push({ startIndex: i.index, length: i[0].length });
    }
    return undefined;
  });

  return occurances;
}
